export default class LocalStorageService {
  get(key) {
    const value = localStorage.getItem(key)
    if (!value) return null

    try {
      return JSON.parse(value)
    } catch (e) {
      console.error("Error parseando localStorage:", key, e)
      return null
    }
  }

  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      console.error("Error guardando en localStorage:", key, e) // ✅
    }
  }

  remove(key) {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      console.error("Error eliminando key de localStorage:", key, e) // ✅
    }
  }

  clear() {
    try {
      localStorage.clear()
    } catch (e) {
      console.error("Error limpiando localStorage", e) 
    }
  }
}
